import React from "react";
import { StyleSheet, Text } from "react-native";

import BaseItemCard from "@/Components/Cards/BaseItemCard";
import { Spacings } from "@/styling/spacings";
import { themes } from "@/Components/Styling/themeConfigs";

const currentTheme = themes.morning;

type Props = {
  icon: string;
  title: string;
  description: string;
  selected?: boolean;
};

function OnboardingWelcomeScreenBaseItem({
  icon,
  title,
  description,
  selected = false,
}: Props): React.JSX.Element {
  const infoComponent = (
    <>
      <Text style={styles.bold}>{title}</Text>
      <Text>{description}</Text>
    </>
  );

  return (
    <BaseItemCard
      leftComponent={<Text style={styles.icon}>{icon}</Text>}
      infoComponent={infoComponent}
      rightComponent={<></>}
      additionalStyle={[styles.container, selected && styles.selectedContainer]}
    />
  );
}

const styles = StyleSheet.create({
  bold: {
    fontWeight: "bold",
  },
  container: {
    marginHorizontal: Spacings.s3,
    paddingHorizontal: Spacings.s3,
    marginVertical: Spacings.s1,
    backgroundColor: "#f5f5f5",
    borderRadius: 20,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "rgba(0, 0, 0, 0.1)",
  },
  selectedContainer: {
    backgroundColor: "#e1f5fe",
    borderColor: "#01579b",
  },
  icon: {
    fontSize: currentTheme.icon.size.mobile.medium,
  },
});

export default OnboardingWelcomeScreenBaseItem;
